<span [matTooltip]="toolTip"
      matTooltipPosition="left"
      #tooltip="matTooltip"
      matTooltipClass="tip">
  {{params.value}}
</span>
